module.exports = __webpack_public_path__ + "img/Data-pipeline.b3214be8.png";